import Button from "components/base/Button";

const ConfirmChangeWarehouseView = ({ stockCategory, confirmHandler }) => {
  return (
    <div>
      <div>
        <p>
          Are you sure you want to change the warehouse to {stockCategory.name}?
        </p>
        <p>
          Every warehouse has different items, the products you select will be
          clear.
        </p>
      </div>

      <hr />

      <div>
        <Button onClick={confirmHandler}>Confirm</Button>
      </div>
    </div>
  );
};

export default ConfirmChangeWarehouseView;
